import { useEffect } from "react";
import { getParameterByName } from "./FunctionsCore";
// Europe
const gLLTQueryParams = ["gLLTSource", "gLLTMedium", "gLLTCampaign", "gLLTContent"];
// America
const UTMQueryParams = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const getParameterValue = (parameterName) => { var _a; return (_a = window.sessionStorage.getItem(parameterName)) !== null && _a !== void 0 ? _a : ""; };
const useUTMQueryParamsPersistence = () => {
    useEffect(() => {
        [...UTMQueryParams, ...gLLTQueryParams].forEach(key => {
            const value = getParameterByName(key);
            if (value !== "") {
                window.sessionStorage.setItem(key, value);
            }
        });
    }, []);
    return {
        "getParameterValue": getParameterValue
    };
};
export { getParameterValue, useUTMQueryParamsPersistence };
